import React from 'react'
import { Link } from 'react-router-dom'

interface IBreadcumb {
  label: string
  path: string
}

interface IProps {
  breadcrumbs: IBreadcumb[]
  className?: string
}

function Breadcrumbs(props: IProps): React.ReactElement {
  return (
    <ul className={`breadcrumbs ${props.className ?? ''}`.trim()}>
      {props.breadcrumbs.map((item, index) => {
        return (
          <li className={'breadcrumbs__item'} key={index}>
            {item.path ? (
              <Link className={'breadcrumbs__item-link'} to={item.path}>
                {item.label}
              </Link>
            ) : (
              <div className={'breadcrumbs__item-link'}>{item.label}</div>
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default Breadcrumbs
